module.exports = __webpack_public_path__ + "media/images/flf-appearance_cloudy-6d505e1b73b17e45322ced17d0e9dab6.jpg";